import { appendIf } from '@btime/helpers'
import { assoc, compose, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'

import { cleanFieldValuesRequest, validateFieldValues } from '../../../../utils/helpers/fields'
import { logAndReturn } from '../../../../utils/helpers/log'
import { placesClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertAsset($input: AssetInput) {
    upsertAsset(input: $input) {
      id
    }
  }
`

const cleanRequest = compose(
  pick(['id', 'name', 'placeId', 'typeId', 'fieldValues', 'enabled']),
  item => assoc('placeId', item?.place?.id ? Number(item.place.id) : null, item),
  item => assoc('typeId', item?.type?.id || null, item),
  item => assoc('fieldValues', cleanFieldValuesRequest(item.fieldValues || []), item)
)

const validate = (form, setErrors) => {
  const errors = [
    ...appendIf(!form.name, { path: ['name'], message: 'Campo obrigatório' }),
    ...validateFieldValues(form)
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveAsset = () => {
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Assets', 'AssetsCount'], client: placesClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
